<template>
  <div class="container mt-5">
    <!-- loading or pending -->
    <div v-if="getPostsApiFetchErrStatus">
      <LoadingFail redirect="posts" />
    </div>
    <!-- fetching error -->
    <div v-else-if="getPostsApiPendingStatus">
      <Pending />
    </div>

    <!-- success -->
    <div v-else>
      <div class="alert alert-warning" role="alert">
        Hi There ! This API is dummy data !
      </div>
      <div class="alert alert-warning" role="alert">Photo API from : picsum.photos</div>
      <div class="alert alert-warning" role="alert">Text API from : jsonplaceholder</div>
      <div class="card-columns mb-5">
        <div
          v-for="(post, index) in getPosts"
          class="card pl-md-3 pr-md-3 pb-md-1 p-2 box"
          :key="index"
        >
          <div class="card-body p-0 pb-1">
            <!-- Title -->
            <h6 class="p-1 text-dark">{{ post.title }}</h6>
            <!-- image -->
            <img
              class="card-img-top border"
              src="https://picsum.photos/200/300"
              height="180px"
              @click="show"
            />
            <!-- date -->
            <div class="date">
              <small class="ml-3">2/2/2020</small>
            </div>
            <!-- footer : hearts,comments -->
            <CardFooter :item="post" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardFooter from "./../components/CardFooter.vue";
import LoadingFail from "./../components/LoadingFail.vue";
import Pending from "./../components/Pending.vue";
export default {
  created() {
    console.log("created");
    this.$store.dispatch("initPostosApi");
  },
  computed: {
    getPosts() {
      return this.$store.getters.getPosts;
    },
    getPostsApiFetchErrStatus() {
      return this.$store.getters.getPostsApiFetchErrStatus;
    },
    getPostsApiPendingStatus() {
      return this.$store.getters.getPostsApiPendingStatus;
    },
  },
  methods: {
    show() {
      alert("show");
    },
    heart() {
      alert("heart");
    },
  },
  components: {
    CardFooter,
    LoadingFail,
    Pending,
  },
};
</script>

<style scoped>
.date {
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  padding: 7px;
  top: 43%;
  border-radius: 5px;
}
</style>
